import ProductModelDetail from './productModelDetailPanel.container';

export default ProductModelDetail;